// @ts-expect-error No types available for this internal Bootstrap module
import SelectorEngine from "bootstrap/js/dist/dom/selector-engine"

export function getBsTriggerElements(element: Element, selectorDataToggle: string): Element[] {
  const triggerArray: Element[] = []
  const toggleList = SelectorEngine.find(selectorDataToggle)

  for (const elem of toggleList) {
    const selector = SelectorEngine.getSelectorFromElement(elem)
    const filterElement = SelectorEngine.find(selector)
      .filter((foundElement: Element) => foundElement === element)

    if (selector !== null && filterElement.length) {
      triggerArray.push(elem)
    }
  }

  return triggerArray
}

export const isMediaBreakpointUp = (name: string) => window.matchMedia(`(min-width: ${breakpoint(name)})`).matches
export const isMediaBreakpointDown = (name: string) => window.matchMedia(`(max-width: ${breakpoint(name)})`).matches

export const breakpoint = (name: string) =>
  getComputedStyle(document.documentElement)
    .getPropertyValue(`--bs-breakpoint-${name}`)
    .trim()
